import { getCustomCDNTokenInfo, uploadToCustomCDN } from '_api/cdnCustom.js';
import { getImageDimension } from '_lib/utils/utilsImg';
export function uploadFiles(uploadInfoList, { type, source, scope = 'chat' }) {
  let infoList = uploadInfoList.map((info) => ({
    ext: info.extension,
    file_size: info.file.size / 1024 / 1024,
  }));
  return new Promise((resolve, reject) => {
    getCustomCDNTokenInfo({ type, source, scope }, infoList)
      .then((res) => {
        if (res.data.status === 'ok') {
          let { info, paths } = res.data.result;
          paths.forEach(
            (path, index) => (path.file = uploadInfoList[index].file)
          );
          let urls = paths.map((path) => `https://${info.host + path.key}`);
          uploadToCustomCDN(
            paths,
            type,
            info,
            (err, data) => {
              resolve({
                info,
                urls,
                data,
              });
            },
            (v) => {
              reject(v);
            }
          );
        } else {
          reject();
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
}
export function uploadFile(
  file,
  config,
  options = {
    progressCallback: (progressEvent) => {},
  }
) {
  // 获取图片的宽高
  return new Promise(async (resolve, reject) => {
    import('_lib/CdnHandler.js').then((cdnModule) => {
      const instance = cdnModule.default;
      instance
        .uploadCustomFile({
          type: config.type,
          source: config.source,
          upload_infos: [
            {
              ext: config.extension,
              file: file,
            },
          ],
        })
        .then((url) => {
          resolve(url);
        })
        .catch((e) => {
          reject(e);
        });
    });
  });
}
